import React from 'react';
import { Box } from '@applyboard/ui-components';
var Frame = function Frame(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement("img", {
    height: "40px",
    width: "40px",
    src: src,
    alt: alt
  }), children);
};
export default Frame;